import { render, staticRenderFns } from "./ItineraryBringSection.vue?vue&type=template&id=5233ed87"
import script from "./ItineraryBringSection.vue?vue&type=script&lang=ts"
export * from "./ItineraryBringSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports